define('prototypes/modernizrTests',['modernizr','js-cookie','UrlFactory'],function(modernizr,Cookies,UrlFactory){
    Modernizr.addTest('android', function () {
        return !!navigator.userAgent.match(/Android/i);
    });
    Modernizr.addTest('ios', function () {
        return !!navigator.userAgent.match(/iOS|iPad|iPhone/i);
    });
    Modernizr.addTest('ipad', function () {
        return !!navigator.userAgent.match(/iPad/i);
    });
    Modernizr.addTest('iphone', function () {
        return !!navigator.userAgent.match(/iPhone/i);
    });
    Modernizr.addTest('retina', function () {
        return (window.devicePixelRatio>1);
    });
    Modernizr.addTest('inapp', function() {
        var inapp = !!Cookies.get('plateform_url_param');
        var plateform = UrlFactory.getUrlParam('plateform');
        if(plateform==='ignore'){
            inapp = false;
            Cookies.remove('plateform_url_param');
        }else if(!inapp){
            inapp = !!plateform;
            if(inapp){
                Cookies.set('plateform_url_param',plateform);
            }
        }
        return inapp;
    })
});
